import { selectCurrentHotelId } from 'accessors'
import Datepicker from 'components/ReusableComponents/Datepicker'
import moment from 'moment'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { updateService } from '../../../actions/hotelDetails'
import { directfulServiceNames } from '../../../main/directfulServices'
import ConfirmationDialog from '../ConfirmationDialog/index'
import Dropdown from '../ManageHotel/Dropdown/index'
import TextInput from '../ManageHotel/TextInput/index'
import styles from './AddServiceDialog.module.scss'

const AddServiceDialog = ({ handleClose, currentServices, billingTaxRate }) => {
  const activeServices = currentServices.map(s => s.plan)

  const [plan, setPlan] = useState('Select a service')
  const [planRate, setPlanRate] = useState('')
  const dispatch = useDispatch()

  const [effectiveDate, setEffectiveDate] = useState(moment().toDate())

  const hotelId = useSelector(selectCurrentHotelId)

  function addService() {
    dispatch(
      updateService({
        action: 'Add',
        plan,
        planRate,
        isFlatMonthly: plan !== 'AutoInvite',
        hotelId,
        effectiveFrom: moment(effectiveDate).format('YYYY-MM-DD')
      })
    )
    handleClose()
  }

  return (
    <ConfirmationDialog
      title="Add new service"
      onClose={handleClose}
      onReject={handleClose}
      onConfirm={addService}
      negativeMessage="Cancel"
      positiveMessage="Add service"
      isButtonDisabled={!(plan !== 'Select a service' && planRate !== '')}
    >
      <div style={{ marginBottom: 5 }}>
        <Dropdown
          label="Service"
          options={Object.keys(directfulServiceNames)
            .filter(s => s !== 'CoreServices')
            .filter(s => s !== 'MarketingWithCommission')
            .filter(s => s !== 'Unlimited')
            .filter(s => s !== 'Basic')
            .filter(s => s !== 'DirectfulCore')
            .filter(s => !activeServices.includes(s))
            .reduce(
              (prev, current) => ({ ...prev, [current]: directfulServiceNames[current] }),
              {}
            )}
          value={plan}
          defaultVal={'Select a service'}
          onChange={e => setPlan(e.target.value)}
          className={styles.dropdown}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
        <TextInput
          type="number"
          label="Commission"
          value={planRate}
          onChange={e => setPlanRate(e.target.value)}
          className={plan === 'AutoInvite' ? styles.percentageInput : styles.dollarInput}
        />
        {plan !== 'AutoInvite' && (
          <span className={styles.taxText}>
            With tax <br />
            <strong> ${((billingTaxRate / 100 + 1) * planRate).toFixed(2)}</strong>
          </span>
        )}
      </div>
      <div>
        <div className={styles.label}>Effective from</div>
        <Datepicker
          className={styles.datepicker}
          selected={effectiveDate}
          onChange={setEffectiveDate}
        />
      </div>
    </ConfirmationDialog>
  )
}

export default AddServiceDialog
